<template>
  <div class="ege-formats v2-container-small">
    <div class="ege-formats__header">
      <h3>
        <span>ФОРМАТЫ ОБУЧЕНИЯ</span>
      </h3>

      <div
        class="ege-formats__consult"
        @click="consultModal = true"
      >
        <img
          src="/v2/ege/formats-education/avatar.png"
          alt="avatar"
          loading="lazy"
        >
        <div>
          <p>Нужна помощь?</p>
          <button
            class="m-btn"
            @click="consultModal = true"
          >
            Спросите специалиста >
          </button>
        </div>
      </div>
    </div>

    <div class="ege-formats__formats">
      <div class="ege-formats__format format format-1">
        <h4 class="format__title">
          <span><b>ОНЛАЙН</b></span> ЗАНЯТИЯ
        </h4>
        <p class="format__text">
          Учитесь в любое время и любом месте, доступ к материалам 24/7
        </p>

        <ul class="format__list">
          <li>
            <img
              src="/v2/ege/formats-education/dot.svg"
              alt="."
              loading="lazy"
            >
            <span>До 4х предметов на выбор</span>
          </li>
          <li>
            <img
              src="/v2/ege/formats-education/dot.svg"
              alt="."
              loading="lazy"
            >
            <span>Доп. занятия с репетитором</span>
          </li>
        </ul>

        <div class="format__price">
          <p>124 ₽ <span>за ак.час</span></p>
          <h5>
            <span class="format__price_from">от</span>
            <b>1 458</b>
            <span class="format__price_month">₽ / мес</span>
          </h5>
          <h6>
            при оплате в рассрочку на&nbsp;12&nbsp;месяца за 1 предмет
          </h6>
        </div>

        <button
          class="format__btn m-btn"
          @click="openSignModal('ОНЛАЙН ЗАНЯТИЯ')"
        >
          Записаться
        </button>
      </div>
      <div class="ege-formats__format format format-2">
        <img
          src="/v2/ege/formats-education/heart.png"
          alt="heart"
          class="format__img"
          loading="lazy"
        >

        <h4 class="format__title">
          <span><b>офлайн</b></span> В МОСКВЕ
        </h4>
        <p class="format__text">
          Обучение в группах до&nbsp;30&nbsp;человек в аудиториях в&nbsp;центре Москвы
        </p>

        <ul class="format__list">
          <li>
            <img
              src="/v2/ege/formats-education/dot-white.svg"
              alt="."
              loading="lazy"
            >
            <span>Только русский и математика</span>
          </li>
          <li>
            <img
              src="/v2/ege/formats-education/dot-white.svg"
              alt="."
              loading="lazy"
            >
            <span>Полная репетиция экзамена</span>
          </li>
          <li>
            <img
              src="/v2/ege/formats-education/dot-white.svg"
              alt="."
              loading="lazy"
            >
            <span>Профориентация</span>
          </li>
        </ul>

        <div class="format__price">
          <p>175 ₽ <span>за ак.час</span></p>
          <h5>
            <span class="format__price_from">от</span>
            <b>5 544</b>
            <span class="format__price_month">₽ / мес</span>
          </h5>
          <h6>
            при оплате в рассрочку на&nbsp;12&nbsp;месяца за 1 предмет
          </h6>
        </div>

        <button
          class="format__btn m-btn"
          @click="openSignModal('офлайн В МОСКВЕ')"
        >
          Записаться
        </button>
      </div>
      <div class="ege-formats__format format format-3">
        <h4 class="format__title">
          <span><b>в мини-</b></span>
          <span><b>группе</b></span>
        </h4>
        <p class="format__text">
          Онлайн-занятия в группах до&nbsp;10&nbsp;человек до 4х раз в&nbsp;неделю
        </p>

        <ul class="format__list">
          <li>
            <img
              src="/v2/ege/formats-education/dot.svg"
              alt="."
              loading="lazy"
            >
            <span>До 4х предметов на выбор</span>
          </li>
        </ul>

        <div class="format__price">
          <p>251 ₽ <span>за ак.час</span></p>
          <h5>
            <span class="format__price_from">от</span>
            <b>3 662</b>
            <span class="format__price_month">₽ / мес</span>
          </h5>
          <h6>
            при оплате в рассрочку на&nbsp;12&nbsp;месяца за 1 предмет
          </h6>
        </div>

        <button
          class="format__btn m-btn"
          @click="openSignModal('в мини-группе')"
        >
          Записаться
        </button>
      </div>
      <div class="ege-formats__format format format-4">
        <h4 class="format__title">
          <span><b>1 на 1</b></span>с экспертом
        </h4>
        <p class="format__text">
          Онлайн-занятия 1 раз в неделю с&nbsp;индивидуальным планом подготовки
        </p>

        <ul class="format__list">
          <li>
            <img
              src="/v2/ege/formats-education/dot.svg"
              alt="."
              loading="lazy"
            >
            <span>До 4х предметов на выбор</span>
          </li>
        </ul>

        <div class="format__price">
          <p>857 ₽ <span>за ак.час</span></p>
          <h5>
            <span class="format__price_from">от</span>
            <b>12 500</b>
            <span class="format__price_month">₽ / мес</span>
          </h5>
          <h6>
            при оплате в рассрочку на&nbsp;12&nbsp;месяца за 1 предмет
          </h6>
        </div>

        <button
          class="format__btn m-btn"
          @click="openSignModal('1 на 1 с экспертом')"
        >
          Записаться
        </button>
      </div>
    </div>

    <div class="ege-formats__includes">
      <h5>
        <span>включено во&nbsp;все&nbsp;форматы</span>
      </h5>
      <div class="ege-formats__includes_items">
        <p
          v-for="(item, index) in formatsIncludes"
          :key="index"
        >
          <img
            src="/v2/ege/formats-education/check.svg"
            alt="check"
            loading="lazy"
          >
          <span v-html="item" />
        </p>
      </div>
    </div>

    <div
      v-show="signInModal || consultModal"
      class="ege-formats-modal"
    >
      <div class="ege-formats-modal__inner">
        <button
          class="ege-formats-modal__close m-btn"
          @click="closeModal"
        >
          <img
            src="/v2/ege-ceny/modal/close-ege.svg"
            alt="close"
            loading="lazy"
          >
        </button>

        <h6
          class="ege-formats-modal__title"
          v-html="getModalTitle"
        />

        <p class="ege-formats-modal__description">
          С&nbsp;тобой свяжется отдел заботы и&nbsp;расскажет подробнее о&nbsp;формате
        </p>

        <div class="ege-formats-modal__fields">
          <form-name-field
            ref="nameField"
            v-model="nameInput"
            class="form__input"
            placeholder="Имя"
          />

          <form-phone-field
            ref="phoneField"
            v-model="phoneInput"
            class="form__input"
            :errors-list="submitError"
            :error="validForm === false"
          />

          <form-email-field
            ref="emailField"
            v-model="emailInput"
            class="form__input"
            :submit-error="submitError"
            placeholder="Почта"
            @clearSubmitError="clearSubmitError"
          />
        </div>

        <button
          class="ege-formats-modal__btn"
          @click="submit"
        >
          {{ getModalButtonText }}
        </button>

        <p class="ege-formats-modal__law">
          Нажимая на кнопку, вы соглашаетесь
          <br>
          <nuxt-link
            to="/privacy"
            target="_blank"
          >
            c условиями обработки данных
          </nuxt-link>
        </p>

        <div class="ege-formats-modal__social">
          <p>
            Или напишите нам в чат:
          </p>

          <div class="ege-formats-modal__social-items">
            <a
              href="https://wa.me/79686286327"
              target="_blank"
              rel="nofollow"
              class="whatsapp"
            >
              <img
                src="/v2/ege-ceny/modal/whatsapp.svg"
                alt="whatsapp"
                loading="lazy"
              >
            </a>
            <a
              :href="$telegramBotLink($route)"
              target="_blank"
              rel="nofollow"
              class="telegram"
            >
              <img
                src="/v2/ege-ceny/modal/telegram.svg"
                alt="telegram"
                loading="lazy"
              >
            </a>
            <a
              href="mailto:online.school@synergy.ru"
              target="_blank"
              rel="nofollow"
              class="email"
            >
              <img
                src="/v2/ege-ceny/modal/email.svg"
                alt="email"
                loading="lazy"
              >
            </a>
          </div>
        </div>
      </div>

      <div
        class="ege-formats-modal__overlay"
        @click="closeModal"
      />
    </div>
  </div>
</template>

<script>
import FormNameField from '@/components/v2/common/fileds/FormNameField.vue';
import FormEmailField from '@/components/v2/common/fileds/FormEmailField.vue';
import FormPhoneField from '@/components/v2/common/fileds/FormPhoneField.vue';
import sendLeadMixinConstructor from '@/mixins/sendLeadMixinConstructor';

const sendLeadMixin = sendLeadMixinConstructor({
  needPhone: true,
  needEmail: true,
  needToSendTitle: true,
  needToSendComments: true,
});

export default {
  name: 'FormatsEducation',
  components: {
    FormPhoneField,
    FormEmailField,
    FormNameField,
  },
  mixins: [sendLeadMixin],

  data: () => ({
    formatsIncludes: [
      'Проверка заданий наставниками',
      'Домашки и&nbsp;контрольные с&nbsp;автопроверкой',
      'Поддержка кураторов',
      'Экзаменационные пробники с&nbsp;проверкой от&nbsp;наставников',
      'Учебные материалы и&nbsp;конспекты к&nbsp;видеоурокам',
      'Вебинар по&nbsp;психологической настройке на&nbsp;экзамен',
      'Онлайн-репетиция по&nbsp;заполнению бланков',
      'Вебинары по&nbsp;темам экзамена и&nbsp;конспекты',
      'Видеоуроки с&nbsp;объяснением теории',
      'Тренажер для&nbsp;отработки заданий',
      'Мастер-классы по&nbsp;профессиям',
    ],
    consultModal: false,
    signInModal: false,
    signInModalComment: null,
  }),

  computed: {
    getModalTitle() {
      if (this.consultModal) {
        return 'Оставьте заявку и получите <span>бесплатную</span> консультацию';
      }
      if (this.signInModal) {
        return 'Узнайте больше о&nbsp;формате и&nbsp;получите <span>бесплатный</span> урок';
      }

      return '';
    },
    titleToSend() {
      return this.getModalTitle.replace(/<\/?[^>]+(>|$)/g, '');
    },
    getModalButtonText() {
      if (this.consultModal) return 'Оставить заявку';
      if (this.signInModal) return 'Записаться';
      return '';
    },
    commentsToSend() {
      return this.signInModalComment;
    },
  },

  methods: {
    openSignModal(coment) {
      this.signInModal = true;
      this.signInModalComment = coment;
    },
    closeModal() {
      this.consultModal = false;
      this.signInModal = false;
      this.signInModalComment = null;
    },
  },
};
</script>

<style scoped lang="scss">

.ege-formats {
  &__header {
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @include media-down(mobile) {
      margin-bottom: 18px;
    }

    h3 {
      position: relative;

      font-weight: 700;
      font-size: 45px;
      line-height: 110%;
      letter-spacing: -0.03em;
      text-transform: uppercase;
      font-feature-settings: 'case' on;
      color: #FFFFFF;

      @include media-down(mobile) {
        margin-left: 8px;
        font-weight: 800;
        font-size: 24px;
        letter-spacing: -0.01em;
      }

      &:before {
        content: '';
        position: absolute;
        width: calc(100% + 16px);
        height: 100%;
        left: -4px;
        top: 0;

        background-color: #FA5019;
        box-shadow: 0 1px 24px rgba(0, 62, 135, 0.2);

        @include media-down(mobile) {
          width: calc(100% + 10px);
        }
      }

      span {
        position: relative;
      }
    }

    .ege-formats__consult {
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;

      @include media-down(tablet) {
        display: none;
      }

      img {
        width: 42px;
        border-radius: 50%;
      }

      p {
        margin-bottom: 1px;
        font-weight: 500;
        font-size: 16px;
        line-height: 21px;
        letter-spacing: -0.16px;
        color: #000000;
      }

      button {
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: -0.16px;
        color: #FA5019;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  &__formats {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;

    @include media-down(laptop) {
      flex-wrap: wrap;
      gap: 12px;
    }

    .format {
      width: 100%;

      @include media-down(laptop) {
        width: calc(50% - 6px);
      }

      @include media-down(mobile) {
        width: 100%;
      }
    }
  }

  &__includes {
    background-color: #EAEFF5;
    box-shadow: inset 8px 8px 30px rgba(87, 106, 135, 0.02), inset 2px 2px 10px rgba(87, 106, 135, 0.02);
    border-radius: 20px;
    padding: 50px 35px 32px;

    @include media-down(mobile) {
      border-radius: 20px;
      padding: 29px 8px 8px;
    }

    h5 {
      position: relative;
      margin-bottom: 32px;
      margin-inline: auto;
      width: fit-content;

      font-weight: 700;
      font-size: 40px;
      line-height: 90%;
      text-align: center;
      letter-spacing: -0.03em;
      text-transform: uppercase;
      font-feature-settings: 'case' on;
      color: #242424;

      @include media-down(tablet) {
        font-size: 32px;
      }

      @include media-down(mobile) {
        max-width: 214px;
        margin-bottom: 15px;
        font-size: 24px;
      }

      &::before {
        @include media-down(mobile) {
          content: '';

          position: absolute;
          width: 153px;
          left: 26px;
          height: 29px;
          top: -3px;

          background-color: #FFFFFF;
        }
      }

      &::after {
        content: '';

        position: absolute;
        width: calc(100% + 14px);
        left: -6px;
        height: calc(100% + 6px);
        top: -3px;

        background-color: #FFFFFF;
        box-shadow: 0 1px 24px rgba(0, 62, 135, 0.2);

        @include media-down(mobile) {
          width: calc(100% + 6px);
          left: -3px;
          height: 29px;
          top: auto;
          bottom: -2px;
          box-shadow: none;
        }
      }

      span {
        position: relative;
        z-index: 2;
      }
    }

    &_items {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      align-items: center;
      justify-content: center;

      @include media-down(mobile) {
        gap: 4px;
      }

      p {
        width: 367px;
        display: flex;
        align-items: flex-start;
        gap: 4px;
        padding: 20px;
        padding-left: 18px;

        background-color: #FFFFFF;
        box-shadow: 10px 10px 22px rgba(7, 21, 57, 0.1), 4px 4px 14px rgba(7, 21, 57, 0.05);
        border-radius: 20px;

        @include media-down(mobile) {
          width: 100%;
          padding: 15px 20px;
          border-radius: 12px;
        }

        img {
          height: 21px;
        }

        span {
          font-weight: 500;
          font-size: 16px;
          line-height: 130%;
          align-items: center;
          color: #000000;

          @include media-down(mobile) {
            font-size: 14px;
          }
        }
      }
    }
  }

  .format {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    position: relative;
    padding: 20px;
    background-image: url("/v2/ege/formats-education/online-bg.webp");
    background-position: right bottom;
    background-size: cover;
    box-shadow: 10px 10px 50px rgba(7, 21, 57, 0.1), 4px 4px 20px rgba(7, 21, 57, 0.05);
    border-radius: 20px;

    @include media-down(tablet) {
      padding: 25px 17px 27px;
    }

    &__title {
      margin-bottom: 20px;
      transform: rotate(-2deg);

      font-weight: 700;
      font-size: 30px;
      line-height: 100%;
      text-transform: uppercase;
      font-feature-settings: 'case' on;
      color: #242424;

      span {
        position: relative;
        display: block;
        color: #FFFFFF;
        width: fit-content;

        &:before {
          content: '';
          position: absolute;
          left: -6px;
          top: -4px;
          width: calc(100% + 14px);
          height: calc(100% + 6px);
          background-color: #4045C3;
          box-shadow: 0 1px 24px rgba(0, 62, 135, 0.2);
        }
      }

      b {
        position: relative;
      }
    }

    &__text {
      min-height: 88px;

      font-weight: 500;
      font-size: 22px;
      line-height: 100%;
      letter-spacing: -0.01em;
      font-feature-settings: 'pnum' on, 'lnum' on;
      color: #919191;

      @include media-down(tablet) {
        font-size: 20px;
      }
    }

    &__list {
      display: flex;
      flex-direction: column;
      gap: 10px;

      li {
        display: flex;
        align-items: center;
        gap: 8px;

        span {
          font-weight: 500;
          font-size: 16px;
          line-height: 21px;
          letter-spacing: -0.16px;
          font-feature-settings: 'pnum' on, 'lnum' on;
          color: #242424;
        }
      }
    }

    &__price {
      margin-top: auto;
      margin-bottom: 20px;

      @include media-down(tablet) {
        margin-bottom: 23px;
      }

      p {
        padding-top: 20px;
        margin-bottom: 3px;

        font-weight: 500;
        font-size: 16px;
        line-height: 90%;
        letter-spacing: -0.02em;
        font-feature-settings: 'pnum' on, 'lnum' on, 'case' on;
        color: #000000;

        span {
          color: #919191;
        }
      }

      h5 {
        display: flex;
        gap: 4px;
        align-items: flex-end;
        margin-bottom: 8px;

        font-weight: 500;
        font-size: 32px;
        line-height: 100%;
        letter-spacing: -0.02em;
        font-feature-settings: 'case' on;
        color: #242424;

        .format__price_from {
          margin-bottom: 3px;
          font-size: 20px;
          line-height: 90%;
        }

        .format__price_month {
          margin-bottom: 4px;
          font-size: 16px;
          line-height: 90%;
        }
      }

      h6 {
        font-weight: 500;
        font-size: 16px;
        line-height: 90%;
        letter-spacing: -0.02em;
        font-feature-settings: 'pnum' on, 'lnum' on;
        color: #919191;
      }
    }

    &__btn {
      width: 100%;
      padding: 13px 13px 17px;
      background-color: #FA5019;
      border-radius: 50px;

      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      font-feature-settings: 'pnum' on, 'lnum' on;
      color: #FFFFFF;

      &:hover {
        background-color: darken(#FA5019, 5%);
      }
    }

    &.format-2 {
      background-image: url("/v2/ege/formats-education/offline-bg.webp");

      .format__img {
        position: absolute;
        top: -20px;
        right: -13px;
        width: 55px;

        @include media-down(laptop) {
          right: 0;
        }
      }

      .format__title {
        color: #FFFFFF;
        transform: rotate(2deg);

        span:before {
          background-color: #FA5019;
        }
      }

      .format__text,
      .format__list li span,
      .format__price p,
      .format__price h5 {
        color: #ffffff;
      }

      .format__price p span,
      .format__price h6 {
        color: rgba(#ffffff, 0.72);
      }
    }

    &.format-4 .format__title {
      transform: rotate(2deg);
    }
  }

  .ege-formats-modal {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    &__inner {
      width: 545px;
      max-height: 98vh;
      overflow: auto;
      box-sizing: border-box;
      padding: 40px 40px 32px;
      position: relative;
      z-index: 1;

      border-radius: 20px;
      background: $white-color;
      box-shadow: 4px 4px 20px 0 rgba($ege-blue-darkest, .05), 10px 10px 50px 0 rgba($ege-blue-darkest, .1);

      @include media-down(tablet) {
        width: 100%;
        max-width: 344px;
        padding: 40px 8px 24px;
      }
    }

    &__close {
      position: absolute;
      right: 10px;
      top: 10px;

      cursor: pointer;
    }

    &__title {
      text-align: center;
      font-size: 34px;
      font-weight: 800;
      line-height: 100%;
      letter-spacing: -1.2px;
      color: $black-color;

      @include media-down(tablet) {
        font-size: 24px;
        letter-spacing: -0.48px;
      }

      ::v-deep span {
        color: #FA5019;
      }
    }

    &__description {
      max-width: 414px;
      margin: 12px auto 32px;

      text-align: center;
      font-variant-numeric: lining-nums proportional-nums;
      font-size: 24px;
      font-weight: 500;
      line-height: 130%;
      color: $grey2;

      @include media-down(tablet) {
        margin: 8px auto 0;

        font-size: 18px;
        font-weight: 600;
        line-height: 100%;
      }
    }

    &__fields {
      .form__input {
        margin: 0 auto 10px;

        @include media-down(tablet) {
          margin-bottom: 8px;
        }

        ::v-deep input:not(.phone-field__input) {
          width: 100%;
          height: auto;
          padding: 21px 18px;

          border-radius: 100px;
          border: 1px solid rgba($black-color, .2);

          font-size: 20px;
          font-weight: 400;
          letter-spacing: 0.4px;
          line-height: 1;
          color: $black-color;

          &::placeholder {
            color: $grey2;
          }

          @include media-down(tablet) {
            padding: 16px 14px 16.5px;

            font-size: 18px;
          }
        }

        ::v-deep .phone-field__input {
          padding-top: 20px;
          padding-bottom: 22px;

          font-size: 20px;
          font-weight: 400;
          letter-spacing: 0.4px;

          @include media-down(tablet) {
            font-size: 18px;
          }
        }
      }
    }

    &__btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 70px;
      margin-top: 20px;

      border-radius: 100px;
      background-color: $ege-orange;
      border: 2px solid $brown-dark;
      box-shadow: 0 4px 0 0 $brown-dark;

      text-align: center;
      font-variant-numeric: lining-nums proportional-nums;
      font-size: 30px;
      color: $white-color;
      font-weight: 700;
      line-height: normal;

      cursor: pointer;
      transition: transform .2s ease-out, box-shadow .2s ease-out;

      @include media-down(tablet) {
        margin-top: 8px;
        height: 60px;

        transform: translate(-4px, -4px);
        box-shadow: 4px 4px 0 0 $black-color;

        font-size: 24px;
      }

      &:hover {
        box-shadow: 0 0 0 0 $brown-dark;
        transform: translate(0, 4px);
      }
    }

    &__law {
      max-width: 384px;
      margin: 10px auto 0;

      text-align: center;
      font-variant-numeric: lining-nums proportional-nums;
      font-size: 18px;
      font-weight: 600;
      line-height: 100%;
      color: #919191;

      @include media-down(tablet) {
        margin-top: 8px;

        font-size: 16px;
        line-height: 120%;
      }

      a {
        color: $ege-orange;
      }
    }

    &__social {
      margin-top: 32px;

      @include media-down(tablet) {
        margin-top: 24px;
      }

      p {
        font-variant-numeric: lining-nums proportional-nums;
        font-size: 20px;
        font-weight: 500;
        line-height: 26px;
        text-align: center;
        color: $black-color;

        @include media-down(tablet) {
          font-size: 16px;
          font-weight: 600;
          line-height: 19px;
        }
      }

      &-items {
        display: flex;
        justify-content: center;
        gap: 10px;
        margin-top: 16px;

        @include media-down(tablet) {
          margin-top: 12px;
        }

        a {
          display: inline-block;
          width: 50px;
          height: 50px;
          overflow: hidden;

          border-radius: 10px;
          transform: translate(-2px, -2px);

          transition: transform .2s ease-out, box-shadow .2s ease-out;

          img {
            width: 100%;
          }
        }
        a.whatsapp {
          border: 2px solid #168B25;
          box-shadow: 2px 2px 0 0 #168B25;

          &:hover {
            transform: translate(0, 0);
            box-shadow: 0 0 0 0 #168B25;
          }
        }
        a.telegram {
          border: 2px solid #016EA3;
          box-shadow: 2px 2px 0 0 #016EA3;

          &:hover {
            transform: translate(0, 0);
            box-shadow: 0 0 0 0 #016EA3;
          }
        }
        a.email {
          border: 2px solid #044396;
          box-shadow: 2px 2px 0 0 #044396;

          &:hover {
            transform: translate(0, 0);
            box-shadow: 0 0 0 0 #044396;
          }
        }
      }
    }

    &__overlay {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;

      background-color: rgba($black-color, 0.3);
      -webkit-backdrop-filter: blur(2.5px);
      backdrop-filter: blur(2.5px);

      cursor: pointer;
    }
  }
}

</style>
